<template>
  <NavComponents />
  <div class="container back">
    <div class="common-layout">
      <el-container>
        <el-header>
          <VideoHeader/>
        </el-header>
        <el-container>
          <el-main>
            <VideoComponents  @uploadChapter='uploadChapter' />
          </el-main>
          <el-aside width="30%" >
            <ViedeoChapter ref="loadChapter"/>
          </el-aside>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script setup>
import VideoComponents from "@/components/aliyun/VideoComponents";
import NavComponents from "@/components/nav/NavComponents.vue";
import ViedeoChapter from '@/components/course/chapter/ViedeoChapter.vue'
import VideoHeader from '@/components/course/chapter/VideoHeader.vue'
import { ref, onMounted } from "vue";
import $ from "jquery";
import { useRoute } from "vue-router";
import router from "@/router/index";
import { ElMessage } from "element-plus";

const Route = useRoute(); //获取到值
const courseId = ref("");
let loadChapter = ref(null);

onMounted(() => {
  // 获取路由参数并设置为 current_page
  courseId.value = Route.params.courseId || '';

  preAuth();
});

const preAuth = () => {
  const token = localStorage.getItem("token");
  $.ajax({
    url: "http://124.222.105.205:5000/api/course/hasPreAuth",
    data: {
      courseId: courseId.value,
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
      if (resp.code == "200") {
        console.log("放行");
      } else {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
        router.push({ name: "home" });
      }
    },
    error() {
      ElMessage({
        type: "error",
        message: "权限不足",
      });
      router.push({ name: "home" });
    },
  });
}

const uploadChapter = () => {
  
  loadChapter.value.pullChapterList();
}



</script>

<style scoped>
.back{
  background-color: rgba(206, 216, 218, 0.37);
}
</style>